import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Spacing, Text } from '@reservamos/elements';
import 'styles/components/purchase/TicketsPanel';

/**
 * EvertecPaymentInfo component renders the payment instructions and a button for Evertec payments.
 * The component includes:
 * - A text component that displays the payment instructions.
 * - A button that, when clicked, reloads the current page.
 * @returns {JSX.Element} The rendered component with payment instructions and a reload button.
 */
const EvertecPaymentInfo = () => {
  const { t } = useTranslation('payment');

  const handleClick = () => {
    window.location.reload();
  };

  return (
    <div className="tickets-panel-content">
      <Spacing vertical size="S">
        <Text size="M" weight="bold">
          {t('evertec_payment_info.instructions')}
        </Text>
        <Button onClick={handleClick} text={t('evertec_payment_info.button')} variant="primary" />
      </Spacing>
    </div>
  );
};

export default EvertecPaymentInfo;
